<template>
  <div>
    <el-cascader
            :placeholder="placeholder?placeholder:'请输入'"
            clearable
            ref="cascader"
            :options="options"
            :props="finalProps"
            :show-all-levels="false"
            :filterable="true"
            @change="change"
            v-model="currentValue" for-test="currentValue" popper-class="select-on-click" >
    </el-cascader>
  </div>
</template>
<style lang="scss">
  .select-on-click {
    .el-radio{
      opacity:0;
      position:absolute;
      width:100%;
      height:100%;
      left: 0;
    }
  }
</style>

<!--☯js-->
<script>
  import * as eventJs from '../../../../../../src/base-components/cascader-select-on-click/event.js'
  const {event, life, watch} = eventJs.default ? eventJs.default : eventJs
  import * as modelJS from '../../../../../../src/base-components/cascader-select-on-click/model.js'
  const model = modelJS.default ? modelJS.default : modelJS
  import * as methodsJs from '../../../../../../src/base-components/cascader-select-on-click/methods.js'
  const methodsSource = methodsJs.default ? methodsJs.default : methodsJs
  import vmConfig from '../../../../core/vmConfigHandler.js'
  // 异步加载某些情况下会出问题，原因未知，所以暂时不采用异步加载
  // r => require.ensure([], () => r(require('%path')), 'c-base-cascader-select-on-click')
  export default {
    name: 'base-cascader-select-on-click', // o not use built-in or reserved HTML elements as component id:img, 意思是不能和html标签同名，那么加个下划线好了
    components: {
      /*import components file template:'base-cascader-select-on-click': require('%path').default,
       */
      /*start:import components file*/
/*end:import components file*/
    },
    ...vmConfig(model, life, event, watch, methodsSource)
  }
</script>